export default {"src":"/_next/static/media/moralis.ef011741.svg","height":76,"width":310,"blurWidth":0,"blurHeight":0};